
import { Component, Prop, Vue } from 'vue-property-decorator'
import StudyCategoryPanel from '@/components/organisms/topPagePanel/StudyCategoryPanel.vue'
import { StudyCategory } from '@/models/StudyCategory'

/**
 * トップページの学習教材表示域
 */
@Component({
  components: {
    StudyCategoryPanel,
  },
})
export default class TopPageStudyCategory extends Vue {
  /** 教材リスト */
  @Prop()
  private studyCategoryList!: StudyCategory.LearningStatusStudyCategory[]

  /** 教材クリック時のイベント */
  @Prop()
  private eventClickStudyCategory!: (studyCategoryId: number) => void

  /** 進捗の表示 */
  @Prop({ default: true })
  private showProgress!: boolean
}
